import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M8.03333 7.93347C7.42947 7.93347 6.83913 7.7544 6.33701 7.41893C5.8349 7.0834 5.44354 6.60654 5.21245 6.04862C4.98135 5.49069 4.92088 4.87677 5.03869 4.28448C5.15651 3.69219 5.44731 3.14814 5.87432 2.72113C6.30134 2.29411 6.8454 2.00331 7.43767 1.88549C8.03 1.76768 8.64387 1.82815 9.2018 2.05925C9.75973 2.29035 10.2366 2.6817 10.5721 3.18381C10.9076 3.68593 11.0867 4.27627 11.0867 4.88016C11.0867 5.28113 11.0077 5.67817 10.8543 6.04862C10.7008 6.41907 10.4759 6.75567 10.1924 7.0392C9.90887 7.32273 9.57227 7.5476 9.2018 7.70107C8.8314 7.85453 8.43433 7.93347 8.03333 7.93347Z M13.4 14.1668H2.60669C2.47462 14.1651 2.34844 14.1119 2.25505 14.0185C2.16165 13.9251 2.10841 13.7989 2.10669 13.6668C2.10845 12.6566 2.51099 11.6884 3.22594 10.9747C3.94089 10.261 4.90982 9.86013 5.92002 9.86013H10.0867C11.0969 9.86013 12.0658 10.261 12.7808 10.9747C13.4957 11.6884 13.8983 12.6566 13.9 13.6668C13.8983 13.7989 13.8451 13.9251 13.7517 14.0185C13.6583 14.1119 13.5321 14.1651 13.4 14.1668Z';
const draw24px =
  'M12.05,11.9a4.58,4.58,0,1,1,4.58-4.58A4.58,4.58,0,0,1,12.05,11.9Zm0-7.65a3.08,3.08,0,1,0,3.08,3.07A3.08,3.08,0,0,0,12.05,4.25Zm8.8,16.25a5.72,5.72,0,0,0-5.72-5.71H8.88A5.72,5.72,0,0,0,3.16,20.5a.75.75,0,0,0,1.5,0,4.22,4.22,0,0,1,4.22-4.21h6.25a4.22,4.22,0,0,1,4.22,4.21.75.75,0,0,0,1.5,0Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PersonAvatarIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'personAvatar'),
) as IconWithRender;

PersonAvatarIcon.displayName = 'PersonAvatarIcon';
PersonAvatarIcon.propTypes = Icon.propTypes;
PersonAvatarIcon.renderIcon = (props) => <PersonAvatarIcon {...props} />;
export default PersonAvatarIcon;
